const actionTypes = require('constants/actionTypes');
const Immutable = require('immutable');

const setInitialState = () => {
    return Immutable.Map().merge({
        isFetching: false,
        completed: false,
        data: {},
        error: false,
    });
};

const reducer = (state = setInitialState(), action) => {
    switch (action.type) {
        case actionTypes.FEATURE_FLAGGING_FETCH_REQUEST:
            return state.merge({
                isFetching: true,
                completed: false,
            });

        case actionTypes.FEATURE_FLAGGING_REQUEST_SUCCESS:
            return state.mergeDeep({
                data: { ...action.data },
                isFetching: false,
                completed: true,
                error: false,
            });

        case actionTypes.FEATURE_FLAGGING_REQUEST_FAILURE:
            return state.merge({
                isFetching: false,
                completed: true,
                error: true,
            });

        default:
            return state;
    }
};

export default reducer;
